import React from 'react';
import PropTypes from 'prop-types';

import styles from './testOverview.scss';

class TestComponentContent extends React.PureComponent {
    static propTypes = {
        className: PropTypes.string.isRequired,
        icons: PropTypes.node,
        title: PropTypes.string.isRequired,
        unwrapChild: PropTypes.bool.isRequired,
        children: PropTypes.node.isRequired,
    };

    static defaultProps = {
        icons: null,
    };

    render() {
        const {
            children,
            className,
            icons,
            title,
            unwrapChild,
        } = this.props;

        if (unwrapChild) {
            return children;
        }

        return (
            <div className={className}>
                <div className={styles.contentWrapper}>
                    <h3>{title}</h3>
                    {children}
                </div>
                {icons}
            </div>
        );
    }
}

export default TestComponentContent;
